/* archive-creator-ui.js — UI for /archive-creator.
 * Engine = window.ArchiveBuilder (7z-wasm build worker). This file is pure
 * UI/UX: selection tree, the settings panel, the advisor card, live progress
 * and the result card. No privacy / no-ads / price claims anywhere.
 */
(function () {
  'use strict';
  var SLUG = 'archive-creator';
  var I = window.ArchiveCreatorI18n || {};
  function L(k) { return I[k] || k; }
  /* Telemetry. `__ae(type, …)` is filtered server-side against
   * AnalyticsEvent::ALLOWED_TYPES — a type that is not on that list is accepted
   * by the endpoint and then silently dropped, so the first version of this
   * tool emitted `build_done`, `advice`, `target_open` … and recorded exactly
   * nothing. `tool_event` is the whitelisted generic envelope other tools use
   * (av-sync-test, projector-*, hdr-test) with the specifics in `action`.
   * Funnel milestones go through the standard types via the Timbrica3D handle
   * so the dashboard's existing tool_stage / tool_complete / tool_error panels
   * see this tool like any other. */
  /* The funnel types (tool_stage / tool_complete / tool_error) are emitted
   * directly rather than through Timbrica3D's handle: that helper lives in
   * 3d-printing-core.js, which this page does not load, so `window.Timbrica3D`
   * is undefined here and every milestone was a silent no-op — the tool would
   * have reported ZERO completions on the dashboard while looking instrumented.
   * All four types are on ALLOWED_TYPES, so calling __ae directly is the same
   * data with one less dependency. */
  function raw(type, data) {
    try { if (window.__ae) window.__ae(type, Object.assign({ slug: SLUG, tool: SLUG }, data || {})); } catch (e) {}
  }
  function ae(action, data) { raw('tool_event', Object.assign({ action: action }, data || {})); }
  function stage(name, data) { raw('tool_stage', Object.assign({ stage: name }, data || {})); }
  function complete(data) { raw('tool_complete', data || {}); }
  function failed(reason, data) { raw('tool_error', Object.assign({ reason: reason }, data || {})); }
  function toast(msg, type) { try { if (window.__toast) window.__toast(msg, type || 'info'); } catch (e) {} }

  var AB = window.ArchiveBuilder;
  var fmtBytes = AB ? AB.fmtBytes : function (n) { return n + ' B'; };

  var root, dropEl, emptyEl, wsEl, listEl, sumEl, adviceEl, tableEl,
      nameEl, formatEl, levelEl, pwEl, pwToggle, pwNote, encNamesRow, encNamesEl,
      splitEl, splitCustom, structEl, junkEl, wrapEl, wrapRow, wrapLabel, estEl, buildBtn, cancelBtn, clearBtn,
      modeNewBtn, modeAppendBtn, targetWrap, targetDrop, targetInfo, targetPwWrap, targetPwInput, targetPwApply,
      excludeEl, excludeNote, excludeRow, filterEl,
      progWrap, progText, progBar, progSub, resultEl, addFilesInput, addFolderInput;

  var builder = null;

  /* false on timbrica.com (window.__CRYPTO_OK, ПП РФ № 313): the password rows
   * are not in the markup there at all — neither for a new archive nor for
   * opening an encrypted one to append to it. Set once the page is read. */
  var canEnc = true;
  /* Detached stand-ins for controls a page may leave out: every code path
   * below keeps working unchanged, their value is always empty. */
  function standIn(tag, type) {
    var el = document.createElement(tag);
    if (type) el.type = type;
    return el;
  }
  var expanded = {};
  var advice = null;
  var adviceToken = 0;
  var building = false;
  var lastResult = null;
  var stagedSelect = 0;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    root = document.querySelector('.arc-root');
    if (!root) return;
    dropEl = document.getElementById('arcDrop');
    emptyEl = root.querySelector('.arc-empty');
    wsEl = root.querySelector('.arc-workspace');
    listEl = root.querySelector('.arc-list');
    sumEl = root.querySelector('.arc-count');
    adviceEl = root.querySelector('.arc-advice');
    tableEl = root.querySelector('.arc-table');
    nameEl = root.querySelector('.arc-name-input');
    formatEl = root.querySelector('.arc-format');
    levelEl = root.querySelector('.arc-level');
    pwEl = root.querySelector('.arc-password');
    pwToggle = root.querySelector('.arc-pw-toggle');
    pwNote = root.querySelector('.arc-pw-note');
    encNamesRow = root.querySelector('.arc-encnames-row');
    encNamesEl = root.querySelector('.arc-encnames');
    splitEl = root.querySelector('.arc-split');
    splitCustom = root.querySelector('.arc-split-custom');
    structEl = root.querySelector('.arc-struct');
    wrapEl = root.querySelector('.arc-wrapfolder');
    wrapRow = root.querySelector('.arc-wrap-row');
    wrapLabel = root.querySelector('.arc-wrapfolder-label');
    junkEl = root.querySelector('.arc-junk');
    estEl = root.querySelector('.arc-estimate');
    buildBtn = root.querySelector('.arc-build');
    defaultBuildLabel = buildBtn.textContent;
    cancelBtn = root.querySelector('.arc-cancel');
    clearBtn = root.querySelector('.arc-clear');
    progWrap = root.querySelector('.arc-progress');
    progText = root.querySelector('.arc-progress-text');
    progBar = root.querySelector('.arc-progress-bar');
    progSub = root.querySelector('.arc-progress-sub');
    resultEl = root.querySelector('.arc-result');
    addFilesInput = root.querySelector('.arc-add-files-input');
    addFolderInput = root.querySelector('.arc-add-folder-input');
    modeNewBtn = root.querySelector('.arc-mode-new');
    modeAppendBtn = root.querySelector('.arc-mode-append');
    targetWrap = root.querySelector('.arc-target');
    targetDrop = document.getElementById('arcTarget');
    targetInfo = root.querySelector('.arc-target-info');
    targetPwWrap = root.querySelector('.arc-target-pw');
    targetPwInput = root.querySelector('.arc-target-pw-input');
    targetPwApply = root.querySelector('.arc-target-pw-apply');
    canEnc = window.__CRYPTO_OK !== false && !!pwEl;
    if (!pwEl) pwEl = standIn('input', 'password');
    if (!pwToggle) pwToggle = standIn('button');
    if (!pwNote) pwNote = standIn('div');
    if (!encNamesRow) encNamesRow = standIn('label');
    if (!encNamesEl) encNamesEl = standIn('input', 'checkbox');
    if (!targetPwWrap) targetPwWrap = standIn('div');
    if (!targetPwInput) targetPwInput = standIn('input', 'password');
    if (!targetPwApply) targetPwApply = standIn('button');
    excludeEl = root.querySelector('.arc-exclude');
    excludeNote = root.querySelector('.arc-exclude-note');
    excludeRow = root.querySelector('.arc-exclude-row');
    filterEl = root.querySelector('.arc-filter');

    if (!window.WebAssembly || typeof Worker === 'undefined' || !AB) {
      root.querySelector('.arc-unsupported').style.display = 'block';
      return;
    }
    builder = AB.create();
    raw('tool_open', {});
    try { if (window.Timbrica3D && Timbrica3D.init) Timbrica3D.init(SLUG); } catch (e) {}

    // ---- ingest paths -------------------------------------------------
    if (dropEl) dropEl.addEventListener('tool-uploader:file', function (e) {
      var fs = (e.detail && e.detail.files) || (e.detail && e.detail.file ? [e.detail.file] : []);
      addFiles(Array.prototype.map.call(fs, function (f) { return AB.entryFor(f, f.webkitRelativePath || f.name); }), 'pick');
    });

    /* A dropped FOLDER never appears in dataTransfer.files — only the
     * webkitGetAsEntry tree has it. The shared uploader reads .files, so a
     * folder drop would land as "nothing happened". Intercept on the wrapper in
     * the CAPTURE phase (an ancestor's capture listener runs before the target's
     * own handlers, unlike a capture listener on the target itself, where
     * registration order decides) and only take over when a directory is
     * actually present — plain file drops keep flowing to the uploader with all
     * its validation and telemetry intact. */
    root.addEventListener('drop', function (e) {
      var dt = e.dataTransfer;
      if (!dt || !dt.items || !dt.items.length) return;
      var hasDir = false;
      for (var i = 0; i < dt.items.length; i++) {
        var it = dt.items[i];
        if (it.kind !== 'file' || !it.webkitGetAsEntry) continue;
        var ent = it.webkitGetAsEntry();
        if (ent && ent.isDirectory) { hasDir = true; break; }
      }
      if (!hasDir) return;
      e.preventDefault();
      e.stopPropagation();
      AB.collectFromDataTransfer(dt).then(function (entries) { addFiles(entries, 'drop_folder'); });
    }, true);
    // A folder dropped anywhere else on the page: the layout's rescue hands the
    // whole drop here instead of flattening it into the zone (see the layout's
    // __offZoneFolder).
    window.__acceptDroppedTree = function (snap) {
      AB.collectFromSnapshot(snap).then(function (entries) { addFiles(entries, 'drop_folder_page'); });
    };
    root.addEventListener('dragover', function (e) {
      if (e.dataTransfer && e.dataTransfer.types && e.dataTransfer.types.indexOf('Files') !== -1) e.preventDefault();
    }, true);

    // Both the empty state and the workspace toolbar carry these buttons.
    var af = root.querySelectorAll('.arc-add-files');
    for (var i = 0; i < af.length; i++) af[i].addEventListener('click', function () { addFilesInput.click(); });
    var ad = root.querySelectorAll('.arc-add-folder');
    for (var k = 0; k < ad.length; k++) ad[k].addEventListener('click', function () { addFolderInput.click(); });
    addFilesInput.addEventListener('change', function () {
      addFiles(Array.prototype.map.call(this.files, function (f) { return AB.entryFor(f, f.name); }), 'add_files');
      this.value = '';
    });
    addFolderInput.addEventListener('change', function () {
      addFiles(Array.prototype.map.call(this.files, function (f) { return AB.entryFor(f, f.webkitRelativePath || f.name); }), 'add_folder');
      this.value = '';
    });

    // ---- settings wiring ----------------------------------------------
    formatEl.addEventListener('change', onFormatChange);
    levelEl.addEventListener('change', function () { dropStaleResult(); syncEstimate(); persist(); });
    pwEl.addEventListener('input', function () { dropStaleResult(); validatePw(); });
    pwToggle.addEventListener('click', function () {
      var show = pwEl.type === 'password';
      pwEl.type = show ? 'text' : 'password';
      pwToggle.setAttribute('aria-pressed', show ? 'true' : 'false');
      pwToggle.textContent = show ? L('pw_hide') : L('pw_show');
    });
    splitEl.addEventListener('change', function () {
      dropStaleResult();
      splitCustom.style.display = splitEl.value === 'custom' ? '' : 'none';
      persist();
    });
    wrapEl.addEventListener('change', function () { syncWrapFolder(); scheduleAdvice(); persist(); });
    structEl.addEventListener('change', function () {
      builder.flatten = !structEl.checked;
      scheduleAdvice();   // a different tree means a different mount + probe
      persist();
    });
    junkEl.addEventListener('change', persist);
    nameEl.addEventListener('input', function () { syncWrapFolder(); persist(); });
    buildBtn.addEventListener('click', startBuild);
    cancelBtn.addEventListener('click', cancelBuild);
    clearBtn.addEventListener('click', clearAll);

    bindSetting(formatEl, 'format', 'zip');
    bindSetting(levelEl, 'level', '5');
    bindSetting(splitEl, 'split', '0');
    bindSetting(structEl, 'structure', true);
    bindSetting(junkEl, 'junk', true);
    builder.flatten = !structEl.checked;

    modeNewBtn.addEventListener('click', function () { setMode('new'); });
    modeAppendBtn.addEventListener('click', function () { setMode('append'); });
    if (targetDrop) targetDrop.addEventListener('tool-uploader:file', function (e) {
      var f = (e.detail && e.detail.file) || (e.detail && e.detail.files && e.detail.files[0]);
      if (f) loadTarget(f, '');
    });
    targetPwApply.addEventListener('click', function () {
      if (pendingTargetFile) loadTarget(pendingTargetFile, targetPwInput.value || '');
    });
    targetPwInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && pendingTargetFile) loadTarget(pendingTargetFile, targetPwInput.value || '');
    });

    excludeEl.addEventListener('input', function () { clearTimeout(excludeTimer); excludeTimer = setTimeout(syncExclude, 250); });
    filterEl.addEventListener('input', applyFilter);
    bindSetting(excludeEl, 'exclude', '');

    onFormatChange();
    syncExclude();
  });

  // ------------------------------------------------------------ append mode
  var mode = 'new';
  var pendingTargetFile = null;
  var defaultBuildLabel = '';

  function setMode(m) {
    if (mode === m) return;
    mode = m;
    modeNewBtn.classList.toggle('is-on', m === 'new');
    modeAppendBtn.classList.toggle('is-on', m === 'append');
    modeNewBtn.setAttribute('aria-selected', m === 'new' ? 'true' : 'false');
    modeAppendBtn.setAttribute('aria-selected', m === 'append' ? 'true' : 'false');
    targetWrap.style.display = m === 'append' ? 'flex' : 'none';
    if (m === 'new') { builder.clearTarget(); pendingTargetFile = null; targetInfo.style.display = 'none'; targetPwWrap.style.display = 'none'; }
    // In append mode the archive's own format, name, split and wrapper are
    // fixed by the file being updated — hiding them beats showing controls
    // that silently do nothing.
    root.querySelector('.arc-settings').classList.toggle('arc-append-mode', m === 'append');
    var hide = m === 'append';
    root.querySelector('.arc-name-input').closest('.arc-field').style.display = hide ? 'none' : '';
    formatEl.closest('.arc-field').style.display = hide ? 'none' : '';
    root.querySelector('.arc-split-row').style.display = hide ? 'none' : '';
    if (wrapRow) wrapRow.style.display = hide ? 'none' : wrapRow.style.display;
    buildBtn.textContent = hide ? L('btn_append') : defaultBuildLabel;
    ae('mode', { mode: m });
    render();
    syncEstimate();
  }

  async function loadTarget(file, password) {
    pendingTargetFile = file;
    targetInfo.style.display = '';
    targetInfo.className = 'arc-target-info';
    targetInfo.textContent = L('opening_target');
    var res;
    try { res = await builder.openTarget(file, password); }
    catch (err) { res = { ok: false, reason: err && err.code === 'MODULE_WORKER_UNSUPPORTED' ? 'ENGINE' : 'UNREADABLE' }; }

    /* The browser cannot start the engine (no module workers) — the archive is fine,
     * «unreadable» would send the person looking for another copy of it. */
    if (res.reason === 'ENGINE') {
      targetPwWrap.style.display = 'none';
      targetInfo.className = 'arc-target-info arc-bad';
      targetInfo.textContent = (window.__requireModuleWorker && window.__requireModuleWorker.text) || L('target_unreadable');
      ae('target_rejected', { reason: 'ENGINE', type: '' });
      syncEstimate();
      return;
    }

    if (res.ok) {
      targetPwWrap.style.display = 'none';
      targetInfo.className = 'arc-target-info';
      targetInfo.innerHTML = '<span>📦</span><span>' + esc(file.name) + '</span>'
        + '<span class="arc-meta">' + esc(L('target_ok')
            .replace('{type}', (res.type || '').toUpperCase())
            .replace('{n}', res.entries)
            .replace('{size}', fmtBytes(res.bytes))) + '</span>'
        + '<span class="arc-spacer"></span>'
        + '<button type="button" class="lg-btn arc-target-change">' + esc(L('target_change')) + '</button>';
      targetInfo.querySelector('.arc-target-change').addEventListener('click', function () {
        builder.clearTarget(); pendingTargetFile = null;
        targetInfo.style.display = 'none'; targetPwWrap.style.display = 'none';
        try { if (targetDrop.__uploaderReset) targetDrop.__uploaderReset(); } catch (e) {}
        syncEstimate();
      });
      ae('target_open', { type: res.type, entries: res.entries, bytes: res.bytes });
      syncEstimate();
      return;
    }

    /* Appending into an encrypted archive means encrypting the new files with
     * its password — not on timbrica.com. Say so instead of asking for it. */
    if (!canEnc && (res.reason === 'NEEDS_PASSWORD' || res.reason === 'WRONG_PASSWORD')) {
      targetInfo.className = 'arc-target-info arc-bad';
      targetInfo.textContent = L('target_crypto_off');
      targetPwWrap.style.display = 'none';
      ae('target_rejected', { reason: 'CRYPTO_OFF', type: res.type || '' });
      syncEstimate();
      return;
    }

    var key = {
      READ_ONLY_FORMAT: 'target_readonly',
      VOLUME: 'target_volume',
      NEEDS_PASSWORD: 'target_needs_pw',
      WRONG_PASSWORD: 'target_wrong_pw',
    }[res.reason] || 'target_unreadable';
    targetInfo.className = 'arc-target-info' + (res.reason === 'NEEDS_PASSWORD' ? '' : ' arc-bad');
    targetInfo.textContent = L(key).replace('{type}', (res.type || '?').toUpperCase());
    // Only a password problem is worth another try in place; the rest need a
    // different file.
    var askPw = res.reason === 'NEEDS_PASSWORD' || res.reason === 'WRONG_PASSWORD';
    targetPwWrap.style.display = askPw ? 'flex' : 'none';
    if (askPw) { targetPwInput.value = ''; targetPwInput.focus(); }
    ae('target_rejected', { reason: res.reason, type: res.type || '' });
    syncEstimate();
  }

  // ------------------------------------------------------- exclude patterns
  var excludeTimer = null;

  function excludePatterns() {
    return (excludeEl.value || '').split(/[,\n]/).map(function (s) { return s.trim(); }).filter(Boolean);
  }

  /* Glob → RegExp for the live preview only. The archive itself is filtered by
   * 7-Zip's own `-xr!` matching; this exists so the field is not a black box —
   * a mask that silently matches nothing (or everything) is worse than none. */
  function globToRe(p) {
    var re = p.replace(/[.+^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '[^/]*').replace(/\?/g, '[^/]');
    return new RegExp('(^|/)' + re + '(/|$)', 'i');
  }

  function excludeMatches() {
    var pats = excludePatterns();
    if (!pats.length) return 0;
    var res = pats.map(globToRe);
    var n = 0;
    for (var i = 0; i < builder.entries.length; i++) {
      var p = builder.entries[i].path;
      for (var k = 0; k < res.length; k++) if (res[k].test(p)) { n++; break; }
    }
    return n;
  }

  function syncExclude() {
    var pats = excludePatterns();
    if (!pats.length) { excludeNote.textContent = ''; excludeNote.className = 'arc-exclude-note'; syncEstimate(); return; }
    var n = builder.entries.length ? excludeMatches() : 0;
    excludeNote.className = 'arc-exclude-note' + (builder.entries.length && !n ? ' arc-warn' : '');
    excludeNote.textContent = (builder.entries.length && !n)
      ? L('exclude_none')
      : L('exclude_hits').replace('{n}', n);
    syncEstimate();
  }

  function bindSetting(el, key, dflt) {
    try { if (window.__toolSettings) window.__toolSettings.bind(SLUG, el, key, dflt); } catch (e) {}
  }
  function persist() { /* __toolSettings.bind already writes on change; hook kept for clarity */ }

  // ---------------------------------------------------------------- selection
  /* Open folders from the top down until the tree would get long. A single
   * collapsed "real ▸" row is technically correct and useless — the point of the
   * list is to let someone confirm what they are about to pack. */
  function autoExpand() {
    // Rows a directory ADDS when opened = its immediate children (sub-folders
    // collapse to one row each). Budgeting by "files underneath" instead makes
    // the very first folder blow the budget and nothing ever opens.
    var kids = Object.create(null);
    var seenDir = Object.create(null);
    for (var i = 0; i < builder.entries.length; i++) {
      var parts = builder.entries[i].path.split('/');
      for (var d = 0; d < parts.length; d++) {
        var parent = parts.slice(0, d).join('/');
        var child = parts.slice(0, d + 1).join('/');
        var isDir = d < parts.length - 1;
        var key = parent + '\u0000' + child;
        if (seenDir[key]) continue;
        seenDir[key] = 1;
        kids[parent] = (kids[parent] || 0) + 1;
        if (isDir) seenDir['D:' + child] = 1;
      }
    }
    var dirs = Object.keys(kids).filter(function (p) { return p !== ''; })
      .sort(function (a, b) { return a.split('/').length - b.split('/').length || a.localeCompare(b); });
    expanded = {};
    var rows = kids[''] || 0;
    for (var k = 0; k < dirs.length; k++) {
      var p2 = dirs[k];
      var parentPath = p2.indexOf('/') === -1 ? '' : p2.slice(0, p2.lastIndexOf('/'));
      if (parentPath !== '' && !expanded[parentPath]) continue;
      if (rows + kids[p2] > 40) break;
      expanded[p2] = true;
      rows += kids[p2];
    }
  }

  function addFiles(entries, source) {
    if (!entries || !entries.length) return;
    var usable = entries.filter(function (e) { return e && e.path && e.size >= 0; });
    var res = AB.mergeEntries(builder.entries, usable);
    autoExpand();
    if (!res.added && res.skipped) toast(L('already_added'), 'info');
    ae('files_added', { source: source, added: res.added, skipped: res.skipped, total: builder.entries.length });
    if (!stagedSelect && builder.entries.length) { stagedSelect = 1; stage('select', { files: builder.entries.length, bytes: builder.totalBytes() }); }
    if (!nameEl.value) nameEl.value = suggestName();
    render();
    scheduleAdvice();
  }

  function suggestName() {
    if (!builder.entries.length) return 'archive';
    if (builder.entries.length === 1) return builder.entries[0].path.split('/').pop().replace(/\.[^.]+$/, '');
    var top = builder.entries[0].path.split('/')[0];
    var allSame = builder.entries.every(function (e) { return e.path.split('/')[0] === top; });
    if (allSame && builder.entries[0].path.indexOf('/') !== -1) return top;
    return 'archive';
  }

  function removePath(prefix, isDir) {
    builder.entries = builder.entries.filter(function (e) {
      return isDir ? e.path.indexOf(prefix + '/') !== 0 : e.path !== prefix;
    });
    builder.reset();
    render();
    scheduleAdvice();
    ae('files_removed', { total: builder.entries.length });
  }

  /* Rename what a file or folder will be CALLED inside the archive. Purely a
   * path edit on the selection — nothing is copied or rewritten, the new name
   * is simply what gets mounted. Renaming a folder moves everything under it. */
  function beginRename(rowEl, path, isDir) {
    var nameEl2 = rowEl.querySelector('.arc-nm');
    if (!nameEl2 || rowEl.querySelector('.arc-nm-edit')) return;
    var current = path.split('/').pop();
    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'arc-nm-edit';
    input.value = current;
    nameEl2.replaceWith(input);
    input.focus();
    var dot = current.lastIndexOf('.');
    input.setSelectionRange(0, (!isDir && dot > 0) ? dot : current.length);

    var done = false;
    var finish = function (commit) {
      if (done) return; done = true;
      var next = AB.normPath((input.value || '').trim().replace(/\//g, '_'));
      if (!commit || !next || next === current) { render(); return; }
      var parent = path.indexOf('/') === -1 ? '' : path.slice(0, path.lastIndexOf('/'));
      var target = parent ? parent + '/' + next : next;
      var taken = builder.entries.some(function (e) {
        return isDir ? e.path.indexOf(target + '/') === 0 : e.path === target;
      });
      if (taken) { toast(L('rename_taken'), 'warning'); render(); return; }
      var from = isDir ? path + '/' : path;
      for (var i = 0; i < builder.entries.length; i++) {
        var e = builder.entries[i];
        if (isDir) { if (e.path.indexOf(from) === 0) e.path = target + '/' + e.path.slice(from.length); }
        else if (e.path === path) e.path = target;
      }
      builder.reset();       // the mount is keyed on the paths, so it must be rebuilt
      ae('rename', { dir: isDir ? 1 : 0 });
      render();
      scheduleAdvice();
    };
    input.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); finish(true); }
      else if (ev.key === 'Escape') { ev.preventDefault(); finish(false); }
    });
    input.addEventListener('blur', function () { finish(true); });
  }

  function clearAll() {
    builder.entries = [];
    builder.reset();
    advice = null;
    lastResult = null;
    resultEl.style.display = 'none';
    render();
    try { if (dropEl && dropEl.__uploaderReset) dropEl.__uploaderReset(); } catch (e) {}
  }

  // Build a folder tree from flat paths so a 5 000-file selection renders as a
  // handful of collapsible rows instead of 5 000 DOM nodes.
  function buildTree() {
    var root_ = { name: '', dirs: Object.create(null), files: [], size: 0, count: 0 };
    for (var i = 0; i < builder.entries.length; i++) {
      var e = builder.entries[i];
      var parts = e.path.split('/');
      var node = root_;
      node.size += e.size; node.count++;
      for (var d = 0; d < parts.length - 1; d++) {
        if (!node.dirs[parts[d]]) node.dirs[parts[d]] = { name: parts[d], dirs: Object.create(null), files: [], size: 0, count: 0, path: parts.slice(0, d + 1).join('/') };
        node = node.dirs[parts[d]];
        node.size += e.size; node.count++;
      }
      node.files.push(e);
    }
    return root_;
  }

  function renderNode(node, depth, html) {
    var dirNames = Object.keys(node.dirs).sort(function (a, b) { return a.localeCompare(b); });
    for (var i = 0; i < dirNames.length; i++) {
      var d = node.dirs[dirNames[i]];
      var open = !!expanded[d.path];
      html.push('<div class="arc-row arc-d' + Math.min(6, depth) + '">'
        + '<button type="button" class="arc-tog" data-dir="' + esc(d.path) + '" aria-expanded="' + open + '">' + (open ? '▾' : '▸') + '</button>'
        + '<span class="arc-ic">📁</span>'
        + '<span class="arc-nm">' + esc(d.name) + '</span>'
        + '<span class="arc-meta">' + d.count + ' · ' + fmtBytes(d.size) + '</span>'
        + '<button type="button" class="arc-ren" data-dir-ren="' + esc(d.path) + '" title="' + esc(L('rename')) + '" aria-label="' + esc(L('rename')) + '">✎</button>'
        + '<button type="button" class="arc-rm" data-dir-rm="' + esc(d.path) + '" title="' + esc(L('remove')) + '" aria-label="' + esc(L('remove')) + '">✕</button>'
        + '</div>');
      if (open) renderNode(d, depth + 1, html);
    }
    var files = node.files.slice().sort(function (a, b) { return a.path.localeCompare(b.path); });
    var shown = files.slice(0, 200);
    for (var j = 0; j < shown.length; j++) {
      var f = shown[j];
      html.push('<div class="arc-row arc-d' + Math.min(6, depth) + '">'
        + '<span class="arc-tog"></span>'
        + '<span class="arc-ic">' + iconFor(f.path) + '</span>'
        + '<span class="arc-nm" title="' + esc(f.path) + '">' + esc(f.path.split('/').pop()) + '</span>'
        + '<span class="arc-meta">' + fmtBytes(f.size) + '</span>'
        + '<button type="button" class="arc-ren" data-file-ren="' + esc(f.path) + '" title="' + esc(L('rename')) + '" aria-label="' + esc(L('rename')) + '">✎</button>'
        + '<button type="button" class="arc-rm" data-file-rm="' + esc(f.path) + '" title="' + esc(L('remove')) + '" aria-label="' + esc(L('remove')) + '">✕</button>'
        + '</div>');
    }
    if (files.length > shown.length) {
      html.push('<div class="arc-row arc-d' + Math.min(6, depth) + ' arc-more">' + L('and_more').replace('{n}', files.length - shown.length) + '</div>');
    }
  }

  function iconFor(p) {
    var m = p.toLowerCase().match(/\.([a-z0-9]+)$/); var e = m ? m[1] : '';
    if (/^(png|jpe?g|gif|webp|bmp|ico|svg|avif|tiff?|heic)$/.test(e)) return '🖼️';
    if (/^(mp3|wav|ogg|flac|m4a|aac|opus)$/.test(e)) return '🎵';
    if (/^(mp4|webm|mov|m4v|mkv|avi)$/.test(e)) return '🎬';
    if (e === 'pdf') return '📕';
    if (/^(zip|7z|rar|tar|gz|bz2|xz|zst)$/.test(e)) return '📦';
    if (/^(doc|docx|xls|xlsx|ppt|pptx|odt|rtf)$/.test(e)) return '📘';
    if (/^(js|ts|json|css|html?|xml|php|py|rb|go|rs|c|h|cpp|java|sh|sql|ya?ml|md)$/.test(e)) return '📜';
    return '📄';
  }

  /* Filter the rendered tree. Purely visual — it never changes what gets
   * archived, which is why hidden rows keep their remove/rename controls in the
   * DOM and the summary keeps counting everything. */
  function applyFilter() {
    var q = (filterEl.value || '').trim().toLowerCase();
    var rows = listEl.querySelectorAll('.arc-row');
    var shown = 0;
    for (var i = 0; i < rows.length; i++) {
      var nm = rows[i].querySelector('.arc-nm');
      var hay = ((nm && (nm.getAttribute('title') || nm.textContent)) || '').toLowerCase();
      var hit = !q || hay.indexOf(q) !== -1;
      rows[i].classList.toggle('arc-nomatch', !hit);
      if (hit) shown++;
    }
    var empty = listEl.querySelector('.arc-filter-empty');
    if (q && !shown) {
      if (!empty) { empty = document.createElement('div'); empty.className = 'arc-filter-empty'; listEl.appendChild(empty); }
      empty.textContent = L('filter_none');
    } else if (empty) { empty.remove(); }
  }

  function render() {
    var n = builder.entries.length;
    if (!n) {
      emptyEl.style.display = '';
      wsEl.style.display = 'none';
      wsEl.classList.remove('active');
      // Clear the stale text too — a hidden node still reports its old content
      // to anything reading textContent, which made a removal look like a no-op.
      sumEl.textContent = '';
      listEl.innerHTML = '';
      adviceEl.style.display = 'none';
      tableEl.innerHTML = '';
      estEl.textContent = '';
      if (filterEl) filterEl.value = '';
      return;
    }
    emptyEl.style.display = 'none';
    wsEl.style.display = 'flex';
    wsEl.classList.add('active');

    var total = builder.totalBytes();
    sumEl.innerHTML = '<b>' + n + '</b> ' + esc(L('files')) + ' · <b>' + fmtBytes(total) + '</b>';

    var html = [];
    renderNode(buildTree(), 0, html);
    listEl.innerHTML = html.join('');

    var togs = listEl.querySelectorAll('.arc-tog[data-dir]');
    for (var i = 0; i < togs.length; i++) togs[i].addEventListener('click', function () {
      var p = this.getAttribute('data-dir'); expanded[p] = !expanded[p]; render();
    });
    var rms = listEl.querySelectorAll('.arc-rm');
    for (var j = 0; j < rms.length; j++) rms[j].addEventListener('click', function () {
      var d = this.getAttribute('data-dir-rm');
      if (d) removePath(d, true); else removePath(this.getAttribute('data-file-rm'), false);
    });
    var rens = listEl.querySelectorAll('.arc-ren');
    for (var r = 0; r < rens.length; r++) rens[r].addEventListener('click', function () {
      var d = this.getAttribute('data-dir-ren');
      beginRename(this.parentNode, d || this.getAttribute('data-file-ren'), !!d);
    });

    applyFilter();

    // single-file selections unlock the single-stream compressors
    updateFormatOptions();
    syncWrapFolder();
    syncExclude();
    syncEstimate();
  }

  /* Offer the wrapper folder only when it would change anything: if every entry
   * already sits under one common top-level directory, the archive is already
   * tidy and the checkbox would just add a redundant level. */
  function syncWrapFolder() {
    var loose = builder.entries.some(function (e) { return e.path.indexOf('/') === -1; });
    wrapRow.style.display = loose ? '' : 'none';
    var name = AB.normPath((nameEl.value || 'archive').trim()) || 'archive';
    wrapLabel.textContent = L('opt_wrap_folder').replace('{name}', name);
    builder.rootFolder = (loose && wrapEl.checked) ? name : '';
  }

  function updateFormatOptions() {
    var single = builder.entries.length === 1;
    var opts = formatEl.querySelectorAll('option[data-single]');
    for (var i = 0; i < opts.length; i++) opts[i].hidden = !single;
    if (!single && /^(gz|bz2|xz)$/.test(formatEl.value)) { formatEl.value = 'zip'; onFormatChange(); }
  }

  /* The result card describes ONE archive. Leaving it on screen while the
   * settings that produced it change invites downloading the wrong file. */
  function dropStaleResult() {
    if (!building && resultEl && resultEl.style.display !== 'none') resultEl.style.display = 'none';
  }

  function onFormatChange() {
    dropStaleResult();
    var f = formatEl.value;
    var meta = null;
    for (var i = 0; i < AB.FORMATS.length; i++) if (AB.FORMATS[i].id === f) meta = AB.FORMATS[i];
    var canPw = !!(meta && meta.password);
    var pwRow = root.querySelector('.arc-pw-row');
    if (pwRow) pwRow.style.display = canPw ? '' : 'none';
    var pwNa = root.querySelector('.arc-pw-unavailable');
    if (pwNa) pwNa.style.display = canPw ? 'none' : '';
    encNamesRow.style.display = (meta && meta.encryptNames) ? '' : 'none';
    root.querySelector('.arc-split-row').style.display = (meta && meta.split) ? '' : 'none';
    // TAR carries no checksums, so "verified" can only mean "structure reads
    // back" — say so rather than implying an integrity guarantee it can't give.
    root.querySelector('.arc-tar-note').style.display = f === 'tar' ? '' : 'none';
    validatePw();
    syncEstimate();
    persist();
  }

  function validatePw() {
    var problem = AB.validatePassword(formatEl.value, pwEl.value);
    if (!pwEl.value) { pwNote.style.display = 'none'; pwNote.className = 'arc-pw-note'; buildBtn.disabled = building; return; }
    if (problem === 'non_ascii') {
      pwNote.style.display = ''; pwNote.className = 'arc-pw-note arc-bad'; pwNote.textContent = L('pw_ascii_only');
      buildBtn.disabled = true; return;
    }
    if (problem === 'too_long') {
      pwNote.style.display = ''; pwNote.className = 'arc-pw-note arc-bad';
      pwNote.textContent = L('pw_too_long').replace('{n}', AB.ZIP_PW_MAX);
      buildBtn.disabled = true; return;
    }
    buildBtn.disabled = building;
    pwNote.style.display = ''; pwNote.className = 'arc-pw-note';
    pwNote.textContent = formatEl.value === 'zip' ? L('pw_zip_note') : L('pw_7z_note');
  }

  // ----------------------------------------------------------------- advisor
  var adviceTimer = null;
  function scheduleAdvice() {
    clearTimeout(adviceTimer);
    if (mode === 'append' || !builder.entries.length) {
      adviceEl.style.display = 'none'; tableEl.innerHTML = '';
      syncEstimate();
      return;
    }
    adviceEl.style.display = '';
    adviceEl.innerHTML = '<div class="arc-advice-loading">' + esc(L('measuring')) + '</div>';
    adviceTimer = setTimeout(runAdvice, 350);
  }

  async function runAdvice() {
    var token = ++adviceToken;
    var t0 = Date.now();
    var a;
    try { a = await builder.advise(); }
    catch (err) {
      if (token !== adviceToken) return;
      adviceEl.style.display = 'none';
      ae('advice_failed', { msg: (err && err.message) || '' });
      return;
    }
    if (token !== adviceToken) return;
    advice = a;
    ae('advice', { ms: Date.now() - t0, rows: a.rows.length, rec: a.recommendation && a.recommendation.id, reason: a.recommendation && a.recommendation.reason });
    renderAdvice();
  }

  function humanSeconds(s) {
    if (s == null) return '—';
    if (s < 1) return L('sec_under_1');
    if (s < 60) return Math.round(s) + ' ' + L('unit_sec');
    if (s < 3600) return Math.round(s / 60) + ' ' + L('unit_min');
    return (s / 3600).toFixed(1) + ' ' + L('unit_hour');
  }

  function renderAdvice() {
    if (!advice || !advice.rows.length) { adviceEl.style.display = 'none'; return; }
    var rec = advice.recommendation;
    var total = builder.totalBytes();
    var recRow = null, bestRow = null;
    for (var i = 0; i < advice.rows.length; i++) {
      if (advice.rows[i].id === (rec && rec.id)) recRow = advice.rows[i];
      if (advice.rows[i].id === (rec && rec.bestId)) bestRow = advice.rows[i];
    }
    var msg = '';
    if (rec && rec.reason === 'incompressible') {
      msg = L('advice_incompressible')
        .replace('{best}', (rec.bestSaved * 100).toFixed(1) + '%')
        .replace('{time}', humanSeconds(bestRow ? bestRow.estSeconds : null));
    } else if (rec && rec.reason === 'diminishing' && bestRow && recRow) {
      msg = L('advice_diminishing')
        .replace('{extra}', ((bestRow.saved - recRow.saved) * 100).toFixed(1) + '%')
        .replace('{times}', Math.max(2, Math.round((bestRow.estSeconds || 1) / (recRow.estSeconds || 1))));
    } else if (recRow) {
      msg = L('advice_best').replace('{saved}', (recRow.saved * 100).toFixed(0) + '%');
    }

    adviceEl.innerHTML = '<div class="arc-advice-head"><span class="arc-advice-icon" aria-hidden="true">💡</span>'
      + '<div><div class="arc-advice-title">' + esc(L('advice_title')) + '</div>'
      + '<div class="arc-advice-msg">' + esc(msg) + '</div></div>'
      + (recRow ? '<button type="button" class="lg-btn lg-btn-primary arc-apply">' + esc(L('advice_apply')) + '</button>' : '')
      + '</div>';
    var ap = adviceEl.querySelector('.arc-apply');
    if (ap) ap.addEventListener('click', function () {
      formatEl.value = recRow.format;
      levelEl.value = String(recRow.level);
      onFormatChange();
      ae('advice_applied', { id: recRow.id });
      toast(L('advice_applied'), 'success');
    });

    var rows = ['<table class="arc-cmp"><thead><tr><th>' + esc(L('col_setting')) + '</th><th>' + esc(L('col_size')) + '</th><th>' + esc(L('col_saved')) + '</th><th>' + esc(L('col_time')) + '</th><th></th></tr></thead><tbody>'];
    for (var k = 0; k < advice.rows.length; k++) {
      var r = advice.rows[k];
      var isRec = rec && r.id === rec.id;
      rows.push('<tr' + (isRec ? ' class="arc-rec"' : '') + '>'
        + '<td>' + esc(labelFor(r)) + (isRec ? ' <span class="arc-pill">' + esc(L('recommended')) + '</span>' : '') + '</td>'
        + '<td>≈ ' + fmtBytes(r.estBytes) + '</td>'
        + '<td>' + (r.saved > 0.001 ? '−' + (r.saved * 100).toFixed(0) + '%' : '—') + '</td>'
        + '<td>≈ ' + humanSeconds(r.estSeconds) + '</td>'
        + '<td><button type="button" class="lg-btn arc-pick" data-id="' + esc(r.id) + '" data-format="' + esc(r.format) + '" data-level="' + r.level + '">' + esc(L('choose')) + '</button></td>'
        + '</tr>');
    }
    rows.push('</tbody></table><div class="arc-cmp-note">' + esc(L('estimate_note')) + '</div>');
    tableEl.innerHTML = rows.join('');
    var picks = tableEl.querySelectorAll('.arc-pick');
    for (var p = 0; p < picks.length; p++) picks[p].addEventListener('click', function () {
      formatEl.value = this.getAttribute('data-format');
      levelEl.value = this.getAttribute('data-level');
      onFormatChange();
      ae('advice_picked', { id: this.getAttribute('data-id') });
    });
    syncEstimate();
  }

  function labelFor(r) {
    var fmt = r.format === '7z' ? '7Z' : r.format.toUpperCase();
    return fmt + ' · ' + L('level_' + r.level);
  }

  /* How much archive the worker heap can hold — owned by ArchiveBuilder, which
   * also hands it to the worker for its «disk refused → build in memory?» call. */
  function memoryCeiling() { return AB.memoryCeiling(); }

  function currentAdviceRow() {
    if (!advice) return null;
    var id = formatEl.value + '-' + levelEl.value;
    for (var i = 0; i < advice.rows.length; i++) if (advice.rows[i].id === id) return advice.rows[i];
    return null;
  }
  function estimatedArchiveBytes() {
    var row = currentAdviceRow();
    return row ? row.estBytes : builder.totalBytes();
  }

  function syncEstimate() {
    if (!builder || !builder.entries.length) { estEl.textContent = ''; estEl.className = 'arc-estimate'; return; }
    var row = currentAdviceRow();
    var total = builder.totalBytes();
    var text, expected;
    if (row) {
      expected = row.estBytes;
      text = L('estimate_line')
        .replace('{size}', fmtBytes(row.estBytes))
        .replace('{time}', humanSeconds(row.estSeconds));
    } else {
      expected = total;
      text = L('estimate_source').replace('{size}', fmtBytes(total));
    }
    var heavy = expected > memoryCeiling();
    estEl.className = 'arc-estimate' + (heavy ? ' arc-warn' : '');
    estEl.textContent = heavy ? text + ' · ' + L('estimate_heavy') : text;
  }

  // ------------------------------------------------------------------- build
  var MAX_PARTS = 200;

  function currentSpec() {
    var custom = parseFloat(splitCustom.value);
    var split = splitEl.value === 'custom'
      ? (isFinite(custom) && custom > 0 ? Math.max(64 * 1024, Math.round(custom * 1024 * 1024)) : 0)
      : parseInt(splitEl.value, 10) || 0;
    var entries = builder.entries;
    var spec = {
      format: formatEl.value,
      level: parseInt(levelEl.value, 10),
      name: (nameEl.value || 'archive').trim(),
      password: canEnc ? (pwEl.value || '') : '',
      encryptNames: canEnc && !!(encNamesEl.checked && formatEl.value === '7z'),
      volumeBytes: split,
      excludeJunk: !!junkEl.checked,
      excludes: excludePatterns(),
      mode: mode,
      /* What the archive is expected to weigh, measured on a sample of the
         user's OWN bytes by advise(). The worker uses it for one thing: to
         refuse BEFORE the work when the output cannot fit in the browser's
         storage, instead of discovering it ten minutes in. Falls back to the
         input total, which is an upper bound for anything already compressed. */
      expectBytes: estimatedArchiveBytes(),
    };
    if (/^(gz|bz2|xz)$/.test(spec.format) && entries.length === 1) spec.sources = ['./' + entries[0].path];
    return spec;
  }

  var buildStart = 0, lastFrame = null;
  async function startBuild() {
    if (building || !builder.entries.length) return;
    if (AB.validatePassword(formatEl.value, pwEl.value)) { validatePw(); return; }
    if (mode === 'append' && !builder.target) { toast(L('target_needed'), 'warning'); return; }

    var run = window.__toolLimit && window.__toolLimit.begin(SLUG);
    if (window.__toolLimit && !run) return;   // daily wall — the module shows the note

    building = true;
    buildBtn.disabled = true;
    cancelBtn.style.display = '';
    resultEl.style.display = 'none';
    progWrap.style.display = 'flex';
    progBar.style.width = '0%';
    progText.textContent = L('preparing');
    progSub.textContent = '';
    buildStart = Date.now();
    lastFrame = null;

    var spec = currentSpec();
    /* A 2 GB archive split at 1 MB is 2 000 volumes — 2 000 download buttons and
     * a folder nobody can reassemble by hand. Refuse with the arithmetic shown
     * rather than producing it. */
    if (spec.volumeBytes > 0) {
      var expected = estimatedArchiveBytes();
      var parts = Math.ceil(expected / spec.volumeBytes);
      if (parts > MAX_PARTS) {
        toast(L('split_too_many').replace('{n}', parts).replace('{max}', MAX_PARTS), 'warning');
        building = false; buildBtn.disabled = false; cancelBtn.style.display = 'none';
        progWrap.style.display = 'none';
        if (run) run.abort();
        return;
      }
    }
    stage('build', { format: spec.format, level: spec.level, mode: mode, files: builder.entries.length });
    ae('build_started', { format: spec.format, level: spec.level, files: builder.entries.length, bytes: builder.totalBytes(), enc: spec.password ? 1 : 0, split: spec.volumeBytes ? 1 : 0 });

    try {
      var out = await builder.build(spec, onProgress);
      lastResult = out;
      showResult(out.result, spec);
      if (run) run.commit();
      complete({ format: spec.format, level: spec.level, mode: mode, files: out.result.files,
        ratio: Math.round(out.result.archiveBytes / Math.max(1, out.result.sourceBytes) * 100),
        verified: out.result.verified ? 1 : 0, ms: out.result.ms });
      ae('build_done', {
        /* `lane` is the whole point of the 2026-09-09 change: opfs = the archive
           was written to disk, memfs = the browser could not and we fell back.
           Without it, the next person measuring this tool cannot tell which
           half of the population they are looking at. */
        lane: out.result.lane || 'memfs', laneWhy: out.result.laneWhy || '',
        format: spec.format, level: spec.level, files: out.result.files,
        srcBytes: out.result.sourceBytes, outBytes: out.result.archiveBytes,
        ratio: Math.round(out.result.archiveBytes / Math.max(1, out.result.sourceBytes) * 100),
        verified: out.result.verified ? 1 : 0, parts: out.result.parts.length, ms: out.result.ms,
      });
    } catch (err) {
      if (run) run.abort();
      if (err && err.code === 'CANCELLED') { ae('build_cancelled', { ms: Date.now() - buildStart }); }
      else {
        // MODULE_WORKER_UNSUPPORTED: the engine's own __requireModuleWorker() toast has just said it.
        if (!(err && err.code === 'MODULE_WORKER_UNSUPPORTED')) toast(errorMessage(err), 'error');
        var bytes = builder.totalBytes();
        failed((err && err.code) || 'build_failed', { format: spec.format, level: spec.level, mode: mode, msg: (err && err.message) || '' });
        ae('build_failed', {
          code: (err && err.code) || '', msg: (err && err.message) || '',
          // The three numbers that told us nothing when they were missing.
          srcMB: Math.round(bytes / 1048576), files: builder.entries.length,
          expectMB: Math.round(estimatedArchiveBytes() / 1048576),
        });
      }
    } finally {
      building = false;
      buildBtn.disabled = false;
      cancelBtn.style.display = 'none';
      progWrap.style.display = 'none';
    }
  }

  function errorMessage(err) {
    var c = err && err.code;
    if (c === 'PW_NON_ASCII') return L('pw_ascii_only');
    if (c === 'PW_TOO_LONG') return L('pw_too_long').replace('{n}', AB.ZIP_PW_MAX);
    /* These two codes exist because runCli now KEEPS the thrown value. Before
       that, an out-of-memory build reached here as the tail of the progress log
       and fell through to the generic line — which is why 90 days of telemetry
       could not tell an OOM from a bad format, and why the answer offered to
       the user ("try another format") was the wrong advice for the commonest
       failure there is. */
    // The browser cannot start the engine at all — «try another format» would be false advice.
    if (c === 'MODULE_WORKER_UNSUPPORTED') return (window.__requireModuleWorker && window.__requireModuleWorker.text) || L('err_build');
    if (c === 'OUT_OF_MEMORY') return L('err_memory');
    if (c === 'DISK_FULL' || c === 'NO_SPACE') return L('err_disk');
    if (c === 'NOT_ENOUGH_SPACE') {
      var d = (err && err.detail) || {};
      return L('err_no_space_pre')
        .replace('{need}', fmtBytes(d.needBytes || 0))
        .replace('{free}', fmtBytes(d.freeBytes || 0));
    }
    if (/worker_crash|out of memory|Aborted/i.test((err && err.message) || '')) return L('err_memory');
    return L('err_build');
  }

  function onProgress(p) {
    var pct = Math.max(0, Math.min(100, p.pct == null ? 0 : p.pct));
    progBar.style.width = pct + '%';
    var head = p.phase === 'verify' ? L('verifying') : (p.phase === 'compress' ? L('compressing') : L('archiving'));
    progText.textContent = head + ' ' + pct + '%';
    var bits = [];
    if (p.file) bits.push(p.file.length > 48 ? '…' + p.file.slice(-46) : p.file);
    if (p.doneBytes && p.totalBytes) {
      var el = (Date.now() - buildStart) / 1000;
      var rate = p.doneBytes / Math.max(0.2, el);
      if (rate > 0) {
        bits.push(fmtBytes(rate) + '/' + L('unit_sec'));
        var left = (p.totalBytes - p.doneBytes) / rate;
        if (left > 1 && left < 36000) bits.push(L('eta') + ' ' + humanSeconds(left));
      }
    }
    progSub.textContent = bits.join(' · ');
    lastFrame = p;
  }

  function cancelBuild() {
    if (!building) return;
    builder.cancel();
  }

  // ------------------------------------------------------------------ result
  function showResult(res, spec) {
    var appending = spec.mode === 'append';
    var fmt = appending ? ((builder.target && builder.target.type) || '') : spec.format;
    var savedPct = (!appending && res.sourceBytes > 0) ? (1 - res.archiveBytes / res.sourceBytes) * 100 : 0;
    var verifyLine = fmt === 'tar'
      ? L('verified_tar')
      : (res.verified ? L('verified_ok') : L('verified_fail'));

    var html = '<div class="arc-result-head">'
      + '<span class="arc-result-icon" aria-hidden="true">📦</span>'
      + '<div class="arc-result-main">'
      + '<div class="arc-result-name">' + esc(res.parts.length > 1 ? res.outName + ' · ' + L('parts_n').replace('{n}', res.parts.length) : res.parts[0].name) + '</div>'
      + '<div class="arc-result-stats">'
      + '<b>' + fmtBytes(res.archiveBytes) + '</b>'
      + (appending ? '' : ' · ' + L('from_size').replace('{size}', fmtBytes(res.sourceBytes)))
      + (savedPct > 0.5 ? ' · <b class="arc-saved">−' + savedPct.toFixed(0) + '%</b>' : '')
      + ' · ' + humanSeconds(res.ms / 1000)   // not toFixed(1): a fast build read as a meaningless "0.0 с"
      + '</div></div></div>';

    html += '<div class="arc-verify' + (res.verified || fmt === 'tar' ? '' : ' arc-bad') + '">'
      + (res.verified || fmt === 'tar' ? '✓ ' : '⚠ ') + esc(verifyLine) + '</div>';

    if (res.appended) {
      html += '<div class="arc-note">' + esc(L('append_done')
        .replace('{before}', res.appended.before)
        .replace('{after}', res.appended.after == null ? '?' : res.appended.after)) + '</div>';
    }

    html += '<div class="arc-dl">';
    for (var i = 0; i < res.parts.length; i++) {
      html += '<button type="button" class="lg-btn lg-btn-primary arc-dl-btn" data-i="' + i + '">'
        + '⬇ ' + esc(res.parts[i].name) + ' <span class="arc-dl-size">' + fmtBytes(res.parts[i].size) + '</span></button>';
    }
    html += '</div>';

    if (res.parts.length > 1) html += '<div class="arc-note">' + esc(L('split_note')) + '</div>';
    if (spec.password && fmt === 'zip') html += '<div class="arc-note">' + esc(L('aes_compat_note')) + '</div>';
    if (res.sha256) {
      html += '<details class="arc-sha"><summary>' + esc(L('checksum')) + '</summary>'
        + '<code class="arc-sha-val">' + esc(res.sha256) + '</code>'
        + '<button type="button" class="lg-btn arc-copy-sha">' + esc(L('copy')) + '</button></details>';
    }
    /* Opening the extractor as a plain link made the user re-pick the archive
     * they had just built. Handoff (the primitive bin-cue-to-iso already uses
     * for iso-extractor) carries the File to the new tab, so "let me check what
     * I made" costs one click. Falls back to the bare link when the primitive
     * is not on the page. */
    var canHandoff = !!(window.__DiskImage && window.__DiskImage.Handoff) && res.parts.length === 1;
    html += '<div class="arc-result-actions">'
      + '<button type="button" class="lg-btn arc-again">' + esc(L('build_again')) + '</button>'
      + (canHandoff
          ? '<button type="button" class="lg-btn arc-inspect">' + esc(L('open_in_extractor')) + '</button>'
          : '<a class="lg-btn" href="/archive-extractor">' + esc(L('open_in_extractor')) + '</a>')
      + '</div>';

    resultEl.innerHTML = html;
    // NOT '' — the stylesheet rule for .arc-result is display:none, so clearing
    // the inline value just falls back to hidden. It needs the flex value the
    // rule's flex-direction expects.
    resultEl.style.display = 'flex';

    var btns = resultEl.querySelectorAll('.arc-dl-btn');
    for (var b = 0; b < btns.length; b++) btns[b].addEventListener('click', function () {
      var idx = parseInt(this.getAttribute('data-i'), 10);
      var chunk = lastResult.chunks[idx];
      /* On the disk lane the chunk IS a File sitting in OPFS — handing it
         straight to the download keeps the bytes out of the heap, which is the
         whole point of building there. Only the memory lane wraps a Uint8Array. */
      var blob = chunk.file || new Blob([chunk.bytes], { type: 'application/octet-stream' });
      if (window.__downloadFile) window.__downloadFile(blob, chunk.name);
      else { var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = chunk.name; a.click(); }
      ae('download', { part: idx, bytes: chunk.file ? chunk.file.size : chunk.bytes.length });
    });
    var copy = resultEl.querySelector('.arc-copy-sha');
    if (copy) copy.addEventListener('click', function () {
      try { navigator.clipboard.writeText(res.sha256); toast(L('copied'), 'success'); } catch (e) {}
    });
    var again = resultEl.querySelector('.arc-again');
    if (again) again.addEventListener('click', function () { resultEl.style.display = 'none'; });
    var inspect = resultEl.querySelector('.arc-inspect');
    if (inspect) inspect.addEventListener('click', function () {
      var chunk = lastResult.chunks[0];
      /* Same two lanes as the download button above: on the disk lane the chunk
         IS a File in OPFS and has no `bytes` — `new File([undefined])` quietly
         makes a 9-byte file spelling "undefined", and the next line threw
         (Sentry TIMBRICA-FRONTEND-JM). Hand the File over as it is. */
      var file = chunk.file || new File([chunk.bytes], chunk.name, { type: 'application/octet-stream' });
      ae('inspect_in_extractor', { bytes: chunk.file ? chunk.file.size : chunk.bytes.length, lane: chunk.file ? 'disk' : 'memory' });
      window.__DiskImage.Handoff.send('archive-extractor', { file: file, sourceSlug: SLUG });
    });

    try { if (window.__announce) window.__announce(L('done_announce')); } catch (e) {}
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
})();
